module.exports = __webpack_public_path__ + "img/logo-big.4a7e9bef.svg";